module.exports = __webpack_public_path__ + "img/pexels-lusina-5721014.12f0b1e1.jpg";